import { Fragment, type FunctionComponent } from "react";
import type { DeliverySetting } from "@/data/DeliverySetting.ts";
import { LL3 } from "@/react/core/I18nCurrency.tsx";
import { setDeliverySetting0 } from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";
import { deliverySettingsRadius } from "@/react/DeliveryManagementView/google-map-logic.ts";
import { LL0 } from "@/react/core/I18nService.tsx";

export type DeliveryFeeCardType = {
  className?: string;
};

const DeliveryFeesTableMobile: FunctionComponent<DeliveryFeeCardType> = ({
  className = "",
}) => {
  return (
    <div
      className={`self-stretch hidden Tablet_768:flex flex-1 flex flex-col items-start justify-start text-left text-[12px] text-[#364150] font-[Mulish] mq768:flex mq768:w-full ${className}`}
    >
      {deliverySettingsRadius()?.map((d: DeliverySetting, index: number) => (
        <Fragment
          key={index}>
          <div
            onClick={() => {
              setDeliverySetting0(d)
            }}
            onDoubleClick={() => {
              console.log(d)
            }}
            className={`self-stretch border-[#364150] border-b-[1px] rounded-[2px] flex flex-col items-start justify-start box-border relative max-h-[150px] text-left text-[12px] text-[#364150] font-[Mulish] mq768:flex mq768:self-stretch mq768:w-auto  ${className}`}
          >
            <div className="bg-[#fff] py-[8px] px-[12px] self-stretch flex flex-row items-start justify-start gap-[8px] z-[0]">
              <div className="flex-1 flex flex-col items-start justify-start gap-[12px]">
                <div className="self-stretch flex flex-col items-start justify-center gap-[2px]">
                  <div className="self-stretch relative">{LL0().deliveryManagement.distanceToKm()}</div>
                  <b className="self-stretch relative text-[15px] text-[#000] overflow-hidden text-ellipsis whitespace-nowrap">
                    {d.distance}
                  </b>
                </div>
                <div className="self-stretch flex flex-col items-start justify-center gap-[2px]">
                  <div className="self-stretch relative">{LL0().deliveryManagement.deliveryCost()}</div>
                  <b className="self-stretch relative text-[15px] text-[#000] overflow-hidden text-ellipsis whitespace-nowrap">
                    {d.cost ? LL3().format.currency(d.cost) : ``}
                  </b>
                </div>
              </div>
              <div className="flex-1 flex flex-col items-start justify-start gap-[12px]">
                <div className="self-stretch flex flex-col items-start justify-center gap-[2px]">
                  <div className="self-stretch relative">{LL0().deliveryManagement.minOrderValue()}</div>
                  <b className="self-stretch relative text-[15px] text-[#000] overflow-hidden text-ellipsis whitespace-nowrap">
                    {d.minOrderValue}
                  </b>
                </div>
                <div className="self-stretch flex flex-col items-start justify-center gap-[2px]">
                  <div className="self-stretch relative">{LL0().deliveryManagement.freeDeliveryFrom()}</div>
                  <b className="self-stretch relative text-[15px] text-[#000] overflow-hidden text-ellipsis whitespace-nowrap">
                    $12
                  </b>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default DeliveryFeesTableMobile;
